import {Header} from '@/components/organisms'
import {AuthContext} from '@/context/Auth/AuthContext'
import {isFeatureEnabled} from '@/helpers/featureToggle'
import {useAppDispatch, useAppSelector} from '@/store'
import {resetToastNotifications, selectShellActive, selectShellPath, setShellPath} from '@/store/slices/commonSlice'
import {selectDarkMode} from '@/store/slices/themeSlice'
import {FeatureToggle} from '@/utils/constants/featuresFlag'
import {useContext, useEffect} from 'react'
import {useLocation, useNavigate} from 'react-router-dom'
import logo from '../../assets/img/logo-pepsico-h.svg'
import {Alert, SidebarMenu} from '../../components/molecules'
import {HeaderExtraItems} from './components/HeaderExtraItems'
export const Template = ({children}) => {
  const {isAuthenticated} = useContext(AuthContext)
  return isAuthenticated ? <Logged>{children}</Logged> : <Logged>{children}</Logged>
}

const Logged = props => {
  const navigate = useNavigate()
  const location = useLocation()
  const shellActive = useAppSelector(selectShellActive)
  const shellPath = useAppSelector(selectShellPath)
  const darkMode = useAppSelector(selectDarkMode)
  const dispatch = useAppDispatch()
  const {toastNotifications} = useAppSelector(state => state.common)
  const isB2BAdmin = location.pathname.includes('b2b-admin')

  useEffect(() => {
    // important: immediately navigate to shellPath received from the top shell & reset it
    if (shellPath) {
      navigate(shellPath)
      setTimeout(() => {
        dispatch(setShellPath(''))
      }, 10)
    }
  }, [shellPath, navigate, dispatch])

  const onToastClose = () => {
    dispatch(resetToastNotifications())
  }
  // bug #19286231 - moving code from Approuter to prevent issue of retriggering redux state on main component, <AppRouter />
  // this code is no longer required
  // const userData = useSelector(state => state?.userDetails)
  // const getUserData = async () => {
  //   if (!isObjectNotEmpty(userData)) {
  //     try {
  //       await UserDetails()
  //       const reqData = {
  //         name: 'Robert',
  //         role: ['admin', 'super-admin'],
  //         country: [{name: 'Mexico', lang: [{langcode: 33, name: 'mexico'}]}],
  //         countryCode: 'mx',
  //         siteId: 21,
  //       }
  //       dispatch(setUserDetails(reqData))
  //     } catch {
  //       console.log('Error')
  //       const reqData = {
  //         name: 'Louis',
  //         role: ['admin'],
  //         country: [{name: 'Turkey', lang: [{langcode: 31, name: 'Turkey'}]}],
  //         countryCode: 'TR',
  //         siteId: 23,
  //       }
  //       dispatch(setUserDetails(reqData))
  //     }
  //   }
  // }
  // useEffect(() => {
  //   getUserData()
  // })
  //bug #19286231 ENDS

  return (
    <>
      {!shellActive && (
        <Header logo={logo} title="B2B Admin Tool">
          {isFeatureEnabled(FeatureToggle.userGuide) && <HeaderExtraItems />}
        </Header>
      )}
      <div
        data-testid="content"
        className={`relative flex h-full ${isB2BAdmin ? 'max-h-[calc(100vh-4rem)]' : 'h-full'}`}
      >
        {!shellActive && <SidebarMenu />}
        <main
          data-testid="content-main"
          data-cy="content-main"
          className={`${darkMode ? 'dark-mode' : ''} ${shellActive ? 'm-0' : 'ml-20 pl-8'} w-full overflow-auto bg-background pr-6 pt-7 text-zinc-800`}
          {...props}
        />

        {toastNotifications.show && (
          <Alert
            data-cy="feedback-alert"
            type={toastNotifications.type}
            message={toastNotifications.message}
            show={toastNotifications.show}
            onCloseClick={onToastClose}
          />
        )}
      </div>
    </>
  )
}
